import { Show } from 'solid-js';
import { gameStore } from '@/stores/gameStore';
import './NotificationToast.css';

export default function NotificationToast() {
  const notification = gameStore.notification;

  return (
    <Show when={notification()}>
      {(notif) => (
        <div 
          class={`notification-toast notification-${notif().type}`}
          onClick={() => gameStore.setNotification(null)}
        >
          <div class="notification-content">
            <span class="notification-icon">
              {notif().type === 'success' && '✅'}
              {notif().type === 'error' && '❌'}
              {notif().type === 'warning' && '⚠️'}
              {notif().type === 'info' && 'ℹ️'}
            </span>
            <span class="notification-message">{notif().message}</span>
          </div>
          <button 
            class="notification-close"
            onClick={(e) => {
              e.stopPropagation();
              gameStore.setNotification(null);
            }}
            aria-label="Close notification"
          >
            ×
          </button>
        </div>
      )}
    </Show>
  );
}